import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { getAlmacenColor, getBadgeStyles } from "../../../../components/ui/badgeColors";
import { useAlmacenes } from "../../hooks/useAlmacenes";

/**
 * Chips con el stock actual de un artículo en cada almacén. `undefined`: la
 * consulta aún no ha respondido; `null`: falló (mismo contrato que useStocks)
 */
const StockAlmacenes = ({ stockPorAlmacen, titulo = "Stock actual por almacén" }) => {
    const { getNombreAlmacen } = useAlmacenes();
    const stocks = Object.entries(stockPorAlmacen ?? {}).sort(([a], [b]) => a.localeCompare(b));

    let contenido;
    if (stockPorAlmacen === null) {
        contenido = <Typography sx={{ fontSize: 12, color: "#6c757d" }}>No se pudo consultar el stock</Typography>;
    } else if (stockPorAlmacen === undefined) {
        contenido = <Typography sx={{ fontSize: 12, color: "#6c757d" }}>Consultando stock...</Typography>;
    } else if (stocks.length === 0) {
        contenido = <Typography sx={{ fontSize: 12, color: "#6c757d" }}>Sin stock en ningún almacén</Typography>;
    } else {
        contenido = (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                {stocks.map(([codigo, cantidad]) => (
                    <Chip
                        key={codigo}
                        label={`${getNombreAlmacen(codigo)}: ${cantidad}`}
                        size="small"
                        sx={getBadgeStyles(getAlmacenColor(codigo), { height: 22, fontSize: 10 })}
                    />
                ))}
            </Box>
        );
    }

    return (
        <Box>
            {titulo && <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 0.5, color: "#495057" }}>{titulo}</Typography>}
            {contenido}
        </Box>
    );
};

export default StockAlmacenes;
